import { CheckWhite } from "../../assets/icons/CheckWhite";
import { AltBox, LabelStyled, RadioButton } from "../../styles/Button";
import { InternetIcon } from "../../assets/icons/Alternatives/InternetIcon";
import { TelefoniaIcon } from "../../assets/icons/Alternatives/TelefoniaIcon";
import { InternetTelefoniaIcon } from "../../assets/icons/Alternatives/InternetTelefoniaIcon";
import { InternetTelefoniaTvIcon } from "../../assets/icons/Alternatives/InternetTelefoniaTvIcon";

interface TabButtonProps {
  text: string;
  id: any;
  name: string;
  tag: string;
  onClick: any;
  checked: boolean;
}

const TabButton = ({
  text,
  id,
  name,
  tag,
  onClick,
  checked,
}: TabButtonProps) => {
  const IconSwitch = (key: string) => {
    switch (key) {
      case "Internet":
        return <InternetIcon />;
      case "Telefonía":
        return <TelefoniaIcon />;
      case "Internet + Telefonía":
        return <InternetTelefoniaIcon />;
      case "Internet + Telefonía + TV":
        return <InternetTelefoniaTvIcon />;

      default:
        return null;
    }
  };

  return (
    <>
      <RadioButton
        type="radio"
        id={id}
        name={name}
        value={text}
        checked={checked}
        onChange={() => {}}
      />
      <LabelStyled
        htmlFor={id}
        whileTap={{ scale: 0.98 }}
        onClick={onClick}
        gr={IconSwitch(text)}
      >
        <AltBox>{checked && <CheckWhite />}</AltBox>
        {IconSwitch(text)} {text}
      </LabelStyled>
    </>
  );
};

export default TabButton;
